module.exports = __webpack_public_path__ + "static/media/Blue Yian Kut-Ku.3981d7e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/eggs/images/Blue Yian Kut-Ku.png
// module id = 100
// module chunks = 0